import { DashboardAction } from '../type';
import * as actionTypes from './actionTypes';

//
// Bookings
//

export function setBooking(id: string, payload: any) {
  const action: DashboardAction = {
    type: actionTypes.ADD_BOOKING,
    id: id,
    payload,
  };

  return action;
}

export function setDeleteBooking() {
  const action: DashboardAction = {
    type: actionTypes.DELETE_BOOKING,
  };

  return action;
}

export function setActionBooking(payload: any) {
  const action: DashboardAction = {
    type: actionTypes.ACTION_BOOKING,
    payload,
  };

  return action;
}

export function setActionBookingId(payload: any) {
  const action: DashboardAction = {
    type: actionTypes.ACTION_BOOKING_ID,
    payload,
  };

  return action;
}

export function setBookingDate(payload: any) {
  const action: DashboardAction = {
    type: actionTypes.ADD_DATE,
    payload,
  };

  return action;
}

//
// Application
//

export function addBranches(payload: any) {
  const action: DashboardAction = {
    type: actionTypes.ADD_BRANCH,
    payload,
  };
  return action;
}

export function setAlert(payload: any) {
  const action: DashboardAction = {
    type: actionTypes.ALERT,
    payload,
  };
  return action;
}

export function setLoading(payload: any) {
  const action: DashboardAction = {
    type: actionTypes.LOADING,
    payload,
  };

  return action;
}

export function setError(payload: boolean) {
  const action: DashboardAction = {
    type: actionTypes.ERROR,
    payload,
  };

  return action
}
